// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.audit-table {\n  padding: 10px;\n  margin-top: 20px;\n  border-collapse: collapse;\n  width: 100%;\n  vertical-align: top;\n}\n.audit-table th,\n.audit-table td {\n  border: 1px solid var(--v-primary-base);\n  padding: 8px;\n}\n.audit-table td:nth-child(2) {\n  white-space: 'pre-line';\n}\n.audit-table th {\n  background-color: var(--v-primary-base);\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
